import { AreaKey, getDefaultAreaKey } from "@/app/_utils/navigation/areaRouteMap";

type AreaModule = "PEN" | "COS";

type AreaAccessConfig = {
  requiredModules: AreaModule[];
  missingModuleTitleKey: string;
  missingModuleDescriptionKey: string;
};

type AreaModuleAvailability = Record<AreaModule, boolean>;

const AREA_ACCESS_CONFIG: Record<AreaKey, AreaAccessConfig> = {
  pension: {
    requiredModules: ["PEN"],
    missingModuleTitleKey: "penRequiredTitle",
    missingModuleDescriptionKey: "penRequiredDescription",
  },
  service: {
    requiredModules: ["COS"],
    missingModuleTitleKey: "cosRequiredTitle",
    missingModuleDescriptionKey: "cosRequiredDescription",
  },
};

export function getAreaAccessConfig(area: AreaKey): AreaAccessConfig {
  return AREA_ACCESS_CONFIG[area];
}

export function createAreaModuleAvailability(
  hasModule: (module: string) => boolean
): AreaModuleAvailability {
  return {
    PEN: hasModule("PEN"),
    COS: hasModule("COS"),
  };
}

export function getDefaultAreaFromModules(
  modules: AreaModuleAvailability
): AreaKey {
  return getDefaultAreaKey(modules.PEN, modules.COS);
}

export function getAvailableAreasFromModules(
  modules: AreaModuleAvailability
): AreaKey[] {
  const areas: AreaKey[] = [];

  if (modules.PEN) {
    areas.push("pension");
  }

  if (modules.COS) {
    areas.push("service");
  }

  if (areas.length === 0) {
    areas.push(getDefaultAreaFromModules(modules));
  }

  return areas;
}

export function canAccessArea(
  area: AreaKey,
  modules: AreaModuleAvailability
): boolean {
  return getAreaAccessConfig(area).requiredModules.every(
    (module) => modules[module]
  );
}
